// Claims list focus when a task newly appears in this list instance
import { useEffect, useRef } from 'react';

export function useTaskListFocusClaim({
  selectedIndex,
  isFocused,
  focusContainer,
  listId,
  focusOwnerId,
}) {
  const canClaimFocus = !listId || !focusOwnerId || focusOwnerId === listId;
  const prevSelectedIndexForFocusRef = useRef(selectedIndex);

  useEffect(() => {
    if (
      selectedIndex > -1 &&
      prevSelectedIndexForFocusRef.current === -1 &&
      !isFocused &&
      canClaimFocus
    ) {
      focusContainer();
    }
    prevSelectedIndexForFocusRef.current = selectedIndex;
  }, [selectedIndex, isFocused, focusContainer, canClaimFocus]);
}
